/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type ButtonActionType = (typeof ButtonActionType)[keyof typeof ButtonActionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ButtonActionType = {
  VIDEO_TRANSITION: 'VIDEO_TRANSITION',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
} as const
